import { render, staticRenderFns } from "./Chome.vue?vue&type=template&id=48387a9e&"
import script from "./Chome.vue?vue&type=script&lang=js&"
export * from "./Chome.vue?vue&type=script&lang=js&"
import style0 from "./Chome.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports